<template>
    <div class="reserve-list">
        <div class="reserve-list-container">
            <list-reserve/>
        </div>
    </div>

</template>

<script>
import ListReserve from "./ListReserve";
export default {
    name: "ReserveList",
    components: {
        ListReserve
    }
}
</script>

<style lang="scss" scoped>

.reserve-list {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
}

</style>
